import React from 'react';
import { range } from 'lodash';
import ContentPlaceholder from './Content';

const PathViewerLoader = () => (
  <div className="PathViewerLoader">
    <div className="PathProgress" />
    <div className="PathContentsList">
      {range(3).map(i => (
        <ContentPlaceholder key={i} />
      ))}
    </div>
  </div>
);

export default PathViewerLoader;
